<template>
  <div class="home-content" @click="handleClick">
    <Head ref="head" :backFn="back"></Head>
    <div :class="[isMaxScreen ? 'pc_terms-and-conditions-container' : 'terms-and-conditions-container']">
      <!-- <div class="page-title">Terms and Conditions</div> -->
      <div class="page-text-container" v-html="workData"></div>
    </div>
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Head from '../../components/head'
import Bottom from '../../components/bottom'
import { enData } from './enData.js'
import { esData } from './esData.js'
import { frData } from './frData.js'
import { deData } from './deData.js'
import { itData } from './itData.js'
import { lang } from '@/locales';
export default {
  name: 'Home',
  components: {
    Head,
    Bottom
  },
  data () {
    return {
      lang
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      }
    }),
    workData(){
      // 根据当前语言返回对应的数据
      const languageData = {
        'en': enData,
        'es': esData,
        'fr': frData,
        'de': deData,
        'it': itData,
      };

      console.log("this.lang",this.lang)
      
      return languageData[this.lang] || enData; // 默认返回英文
    }
  },
  mounted(){
    window.scrollTo(0, 0);
  },
  methods: {
    handleClick(){
      this.$refs.head.hidLangeList();
    },
    back(){
      this.$router.go(-1);
      // this.$router.push({ name: 'Home' });
    },
    // 跳转页面
    toPage (name) {
      if (!this.checked && name === 'Product') return
      this.$router.push({ name });
    },
  }
}
</script>
<style scoped lang="less">
@media (min-width: 981px) {

  
  .home-content {
    width: 100%;
    min-height: 100%;
    background: #FFF;
    font-family: "PingFang SC";
    .pc_terms-and-conditions-container{
      padding: 160px 0 120px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .page-title{
        color: #252629;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 40px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
        margin-bottom: 20px;
      }
      /deep/.page-text-container{
        max-width: 1400px;
        margin: auto;
        .paragraph{
          margin-bottom: 32px;

          .title{
            color:  #252629;
            font-family: "PingFang SC";
            font-size: 28px;
            font-style: normal;
            font-weight: 500;
            line-height: 150%;
            margin-bottom: 12px;
            text-align: center;
            font-weight: bold;
          }
          .text-box{
            .text{
              color: #333;
              font-family: "PingFang SC";
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%;
              .email{
                color: #165DFF;
                font-family: "PingFang SC";
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%;
                cursor: pointer;
              }
            }
          }
        }

      }
    }
  }
}
@media (max-width: 980px) {
.home-content {
  width: 100%;
  min-height: 100%;
  background: #FFF;
  font-family: "PingFang SC";
  .terms-and-conditions-container{
    padding:148px 30px 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .page-title{
      color: #252629;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 48px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
      margin-bottom: 48px;
    }
    /deep/.page-text-container{
      width: 100%;
      .paragraph{
        margin-bottom: 32px;

        .title{
          color:  #252629;
          font-family: "PingFang SC";
          font-size: 32px;
          font-style: normal;
          font-weight: 500;
          line-height: 150%;
          margin-bottom: 24px;
          text-align: center;
          font-weight: bold;
        }
        .text-box{
          .text{
            color: #333;
            font-family: "PingFang SC";
            font-size: 28px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            .email{
              color: #165DFF;
              font-family: "PingFang SC";
              font-size: 28px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%;
            }
          }
        }
      }

    }
  }
}

}
</style>